/** Authored correction copy; never include submitted values or server details. */
const fields: Record<string, [string, string]> = {
  serviceCategory: ['Service', 'Choose Food, Grocery, Pharmacy, Parcel or Other.'],
  pickupSource: ['Pickup', 'Choose a verified, saved, recent or custom pickup.'],
  directoryBranchId: ['Verified store', 'Choose an available verified store branch.'],
  savedPickupId: ['Saved pickup', 'Choose an available saved pickup or enter a custom pickup.'],
  recentOrderId: ['Recent pickup', 'Choose an available recent pickup or enter a custom pickup.'],
  pickupName: ['Pickup label', 'Enter a pickup label of 2–160 characters.'],
  pickupAddress: ['Written address', 'Keep the pickup address within 500 characters.'],
  pickupInstructions: ['Pickup instructions', 'Keep pickup instructions within 1,000 characters.'],
  pickupCoordinates: ['Pickup pin', 'Choose valid pickup coordinates: latitude −90 to 90 and longitude −180 to 180.'],
  pickupConfirmed: ['Pickup pin', 'Review and confirm the pickup pin.'],
  dropoffAddress: ['Written delivery address', 'Enter a delivery address of 5–500 characters.'],
  dropoffCoordinates: ['Delivery pin', 'Choose valid delivery coordinates: latitude −90 to 90 and longitude −180 to 180.'],
  deliveryAddressId: ['Saved delivery address', 'Choose an available saved address or enter delivery details manually.'],
  deliveryConfirmed: ['Delivery pin', 'Review and confirm the delivery pin.'],
  recipientName: ['Recipient name', 'Enter a recipient name of 2–160 characters.'],
  recipientPhone: ['Contact number', 'Enter a contact number of 7–30 characters using digits, spaces, +, parentheses or hyphens.'],
  items: ['Items', 'Add 1–50 named items with whole quantities from 1 to 999.'],
  parcelDescription: ['Parcel description', 'Describe the parcel within 1,000 characters.'],
  deliveryInstructions: ['Delivery instructions', 'Keep delivery instructions within 1,000 characters.'],
  purchaseBudgetCentavos: ['Maximum purchase budget (PHP)', 'Enter a valid purchase budget, within PHP 100,000 and with at most two decimal places.'],
  fundingSource: ['Purchase funding', 'Select purchase funding appropriate to the entered budget.'],
  estimatedWeightGrams: ['Estimated total weight (kg)', 'Enter a total weight from 0.001 to 500 kg, with at most three decimal places.'],
  packageCount: ['Packages or bags', 'Enter a whole package count from 1 to 100.'],
  packageSize: ['Largest package size', 'Choose Small, Medium, Large or Bulky.'],
  clientRequestId: ['Saved request', 'The saved request identifier is invalid. Keep your details and contact support before submitting.'],
};
export function orderFieldLabel(field: string): string {
  const item = /^items\.(\d+)\.(name|quantity|notes)$/.exec(field);
  return item ? `Item ${Number(item[1]) + 1} ${item[2]}` : fields[field]?.[0] ?? 'Order details';
}
export function orderFieldMessage(field: string): string {
  if (/^items\.\d+\.quantity$/.test(field)) return 'Enter a whole quantity from 1 to 999.';
  if (/^items\.\d+\.notes$/.test(field)) return 'Keep item notes within 500 characters.';
  if (/^items\.\d+\.name$/.test(field)) return 'Enter an item name of 1–160 characters.';
  return fields[field]?.[1] ?? 'Review this order value before submitting.';
}
export function orderValidationErrors(issues: readonly { path: readonly PropertyKey[]; code: string; message: string }[], itemIndices?: readonly number[]): Record<string, string> {
  const result: Record<string, string> = {};
  for (const issue of issues) {
    const parts=[...issue.path];
    if(parts[0]==='items' && typeof parts[1]==='number' && itemIndices?.[parts[1]]!==undefined) parts[1]=itemIndices[parts[1]]!;
    const path = parts.map(String).join('.');
    const field = /^(pickupCoordinates|dropoffCoordinates)(\.|$)/.exec(path)?.[1] ?? path;
    if (!Object.hasOwn(result, field)) result[field] = issue.code === 'custom' ? issue.message : orderFieldMessage(field);
  }
  return result;
}
export function orderErrorTarget(field: string): string {
  if (['pickupSource', 'directoryBranchId', 'savedPickupId', 'recentOrderId', 'pickupCoordinates', 'pickupConfirmed'].includes(field)) return 'pickupLocation';
  if (['dropoffCoordinates', 'deliveryConfirmed', 'deliveryAddressId'].includes(field)) return 'deliveryLocation';
  return field;
}
